import * as React from 'react';
import type { RestrictionEvent } from 'contracts/restricted-products/restricted-products';
import { cn } from 'lib/utils';

type Props = React.ComponentProps<'div'> & {
  justification: RestrictionEvent['justification']
}

export const EventJustificationStatus = ({ justification, className, ...props }: Props) => {
  return (
    <div className={cn('flex items-center gap-2', className)} {...props}>
      <div className={cn('rounded-full w-3 h-3', justification ? 'bg-green-500' : 'bg-yellow-500')} />
      <span>{justification ? 'justificado' : 'não justificado'}</span>
    </div>
  );
};